export default __webpack_public_path__ + "static/NBInternationalPro-Medium-b052dae48874885f3110e967ce224d9f.woff";